import * as React from "react"
import Footer from "../components/footer"
import Navbar from "../components/navbar"
import Produtos from "../components/sections/produtos"

/*
 * Produtos now lives on the home page, which is one scrolling document. This
 * route is kept so links to /product/ shared before the merge still resolve.
 * It renders the same section, on its own. Nothing links here any more.
 *
 * Note that the ficha-técnica anchors were renamed from #first-section /
 * #second-section / #third-section to #malharia / #estamparia / #entretelas,
 * so a deep link using the old names lands on the page but does not open a
 * line. The page is what it always was otherwise.
 */
export default function Product() {
  return (
    <React.Fragment>
      <Navbar />
      <Produtos />
      <Footer />
    </React.Fragment>
  )
}
